





import {Vue, Component} from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class ToolbarMixin extends Vue {
    public get hideNavigation() {
        return !this.isMD(true);
    }
    public get useSmallText() {
        return this.isMD(false);
    }
    public get navItemMargin() {
        return {
            'ml-3': !this.isLG(false),
            'mr-3': !this.isLG(false),
            'ml-2': this.isLG(false),
            'mr-2': this.isLG(false),
        };
    }

}
